import { render, staticRenderFns } from "./ConvoyInfoPanel.vue?vue&type=template&id=42007284&scoped=true&"
import script from "./ConvoyInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ConvoyInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConvoyInfoPanel.vue?vue&type=style&index=0&id=42007284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42007284",
  null
  
)

export default component.exports